var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseCross(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.9142 5.02175L9.9194 1.01654C10.2123 0.723652 10.6872 0.723652 10.9801 1.01654C11.273 1.30944 11.273 1.78431 10.9801 2.07721L6.97486 6.08241L10.9801 10.0876C11.273 10.3805 11.273 10.8554 10.9801 11.1483C10.6872 11.4412 10.2123 11.4412 9.9194 11.1483L5.9142 7.14307L1.90899 11.1483C1.6161 11.4412 1.14123 11.4412 0.848332 11.1483C0.555439 10.8554 0.555439 10.3805 0.848332 10.0876L4.85354 6.08241L0.848332 2.07721C0.555439 1.78431 0.555439 1.30944 0.848332 1.01655C1.14123 0.723652 1.6161 0.723652 1.90899 1.01655L5.9142 5.02175Z",
    fill: "#242833"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCross);
export default __webpack_public_path__ + "static/media/close-cross.405493946371d7091a13201d4f765c14.svg";
export { ForwardRef as ReactComponent };